import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { compose, graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { getQuestionsPreview } from 'legacy/src/queries';
import withLearnosityConfig from 'legacy-src/utility/withLearnosityConfig';

import PreviewPlayer from './main';

const QuestionPreviewPlayer = (props) => {
  const [playerReady, setPlayerReady] = useState(false);
  const { learnosityServerData, onQuestionChanged, questions } = props;

  useEffect(() => {
    const items = learnosityServerData && learnosityServerData.request.items;
    if (items) {
      setPlayerReady(true);
    }
  }, [learnosityServerData]);

  if (!playerReady) {
    return null;
  }

  return (
    <PreviewPlayer
      {...props}
      className="question-preview-player"
      onQuestionChanged={(questionId) => {
        if (onQuestionChanged) {
          const question = questions.find(
            (question) => question.itemId === questionId,
          );
          onQuestionChanged(question);
        }
      }}
    />
  );
};

const withQuestionsPreview = graphql(getQuestionsPreview, {
  options: ({
    itemId,
    itemIds,
    isSingleQuestionPreview,
    learnosityConfig,
    userData,
    subjectInitId,
  }) => {
    /**
     * for QB created Quiz  preview use the questionIds
     * so we get a learnositySignedRequest with all the item references
     * */
    let graphqlParams = {
      questionId: null,
      questionIds: itemIds,
    };

    if (isSingleQuestionPreview) {
      graphqlParams.questionId = itemId;
    }

    return {
      fetchPolicy: 'network-only',
      variables: {
        ...graphqlParams,
        config: JSON.stringify(learnosityConfig),
        educationPeriod: userData.chosenEducationPeriodCode,
        subjectId: parseInt(subjectInitId, 10),
      },
    };
  },
  props: ({ data }) => {
    const { loading, questionsPreview } = data;

    if (!loading && questionsPreview) {
      const { learnositySignedRequest, allowCalculatorForItems, questions } =
        questionsPreview;
      const cleanQuestions = questions.map((q) => ({ ...q, itemId: q.id }));
      return {
        loading,
        questions: cleanQuestions,
        learnosityServerData: JSON.parse(learnositySignedRequest),
        allowCalculatorForItems,
      };
    }
  },
});

export default compose(
  withRouter,
  connect((state) => state),
  withLearnosityConfig(),
  withQuestionsPreview,
)(QuestionPreviewPlayer);
